// Local Deps
import { makeGraphQLRequest } from '../../utils/requestUtils';

export async function querySupplierCaps(criteria) {
  // Format query
  const query = `query SupplierSearch($criteria: SupplierSearchInput ) { 
    supplierSearch(supplierCriteria: $criteria )
    { 
      suppliers{
        
          cage,
          company,
          address,
          city,
          state,
          poc,
          zip,
          email,
          url,
          phone,
        
      }
      supplierAggs
    } 
  }`;
  // Variables
  const variables = { criteria: { ...criteria } };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function getSupplierSearchMenu() {
  const query = `query getSupplierSearchMenu {
    getSupplierSearchMenu {
      menu 
      menuCamelCase
    }
  }`;

  const variables = {};
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}

export async function getContractCenterData(id) {
  const query = `query ContractCenter(
    $id: ID
  ) {
    ContractCenter(id: $id) {

      contractData{ 
        rfq {
          drafts
          submitted
        }
      
      }
      }
    }`;

  // Variables
  const variables = { id };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response.ContractCenter.contractData;
}

export async function addParticipants(userId, rfqId, participants) {
  const query = `mutation addParticipants($userId: ID, $rfqId: Int, $participants: [String]) { addParticipants (userId: $userId, rfqId: $rfqId, participants: $participants) { status  } }`;

  // Variables

  const variables = {
    userId,
    rfqId,
    participants,
  };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response.addParticipants;
}



// WEBPACK FOOTER //
// ./src/pages/SupplierCapabilities/graphql.js